<template lang="pug">
div
  v-text-field(:clearable="clearable" :disabled="disabled" @click:clear="clear" @click:append="menuOpen = !menuOpen" append-icon="event" :label="label" :placeholder="placeholder" :value="showDate" @change="textInput" :hide-details="hideDetails" :error-messages="errorArray")
  v-menu(lazy :close-on-content-click="false" v-model="menuOpen" transition="scale-transition" offset-y full-width :nudge-right="40" max-width="290px" min-width="290px")
    .not-activator(slot="activator")
    v-date-picker(:value="pickerDate" @input="pickerInput" locale="de-DE" first-day-of-week="1" scrollable autosave)

</template>

<style lang="stylus">
.not-activator
  width 100%
  height 0
</style>

<script>
import moment from 'moment'

export default {
  name: 'input-datetime',
  props: {
    value: true,
    label: String,
    placeholder: String,
    clearable: Boolean,
    hideDetails: Boolean,
    disabled: Boolean,
    errorMessages: {
      type: Array,
      default() { return [] }
    }
  },
  data() {
    return {
      error: null,
      menuOpen: false,
      forceUpdate: 0
    }
  },
  computed: {
    moment() {
      return moment(this.value, "YYYY-MM-DD H:mm Z")
    },
    showDate() {
      const force = this.forceUpdate % 2 === 0 ? '' : ' '
      if (this.moment.isValid()) {
        return this.moment.format('DD.MM.YYYY H:mm') + force
      } else {
        return force
      }
    },
    pickerDate() {
      if (this.moment.isValid()) {
        return this.moment.format('YYYY-MM-DD')
      } else {
        return null
      }
    },
    errorArray() {
      const arr = []
      if (this.error || (this.value && !this.moment.isValid())) {
        arr.push('ungültig TT.MM.JJJJ HH:MM')
      }
      return arr.concat(this.errorMessages)
    }
  },
  watch: {
    value() {
      this.forceUpdate++
      this.error = null
    }
  },
  methods: {
    pickerInput(value) {
      this.menuOpen = false
      let date = moment(value, "YYYY-MM-DD")
      if (date.isValid()) {
        date.hour(this.moment.hour())
        date.minute(this.moment.minute())
        this.$emit('input', date.toISOString())
      }
      this.forceUpdate++
    },
    textInput(value) {
      window.m = moment
      if (value) {
        const date = moment(value, "DD.MM.YYYY H:mm")
        if (date.isValid()) {
          if (date.year() < 1000) {
            date.year(date.year() + 2000)
          }
          this.$emit('input', date.toISOString())
          this.forceUpdate++
        } else {
          this.error = true
        }
      } else {
        this.$emit('input', null)
        this.forceUpdate++
      }
    },
    clear() {
      this.$emit('input', null)
      this.forceUpdate++
    }
  }
}
</script>
